<template>
  <div class="featured-category-small">
    <div class="featured-category-small__container">
      <component
        :is="titleElement"
        v-if="title"
        class="featured-category-small__title text-mobile-headlines-h3 text-desktop-headlines-h3"
        v-text="title"
      />

      <div
        class="featured-category-small__thumbnail-container"
        js-body-scroll-lock-ignore
      >
        <div
          v-for="link of links"
          :key="link.handle"
          class="featured-category-small__thumbnail-slide"
        >
          <a
            class="featured-category-small__thumbnail-wrapper"
            :href="link.url"
          >
            <div class="featured-category-small__thumbnail">
              <responsive-image
                class="featured-category-small__image"
                :image="link.image"
                :padding="false"
                :ratio="false"
                sizes="(min-width: 1024px) 32px, 45px"
                widths="45, 90, 135"
              />
            </div>

            <p
              class="featured-category-small__thumbnail-label text-mobile-paragraph-m-regular text-desktop-paragraph-s-regular"
              v-text="link.title"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Vue: Featured category small inner (featured-category-small)
 * -----------------------------------------------------------------------------
 * Featured category small section.
 * - For use as a component in Vue sections.
 *
 * @param {Array} links - Collection links.
 * @param {String} title - Title.
 * @param {String} [titleElement] - Title element.
 *
 */
import ResponsiveImage from '~global/images/responsive-image';

export default {
  name: 'FeaturedCategorySmallInner',

  components: {
    ResponsiveImage,
  },

  props: {
    links: {
      type: Array,
      default: () => [],
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    titleElement: {
      type: String,
      default: 'h2',
    },
  },
};
</script>

<style lang="scss">
@import './featured-category-small';
</style>
